
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[shop]",
      function () {
        return require("private-next-pages/[shop]/index.page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[shop]"])
      });
    }
  